export default "__VITE_PUBLIC_ASSET__dfd2f28d__"